<!-- eslint-disable vue/require-v-for-key -->
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Multiselect from 'vue-multiselect'
import { Helper, debounce } from '@/mixin/helper'
import { required } from 'vuelidate/lib/validators'

import { GET_COMPANYS } from '@/services/api/master/companies'
import { mapGetters } from 'vuex'
import { getToolsClient } from '@/services/tools'

import Confirmation from '@/components/widgets/modals/Confirmation'
import { getSmsClient } from '@/services/sms'

const toolsAxios = getToolsClient()
const smsAxios = getSmsClient()
/**
 * Starter component
 */
export default {
  page: {
    title: 'Tambah Device Status',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    Confirmation,
  },
  apollo: {
    companies: {
      query: GET_COMPANYS,
    },
  },
  mixins: [Helper],
  data() {
    return {
      selectedDevicesFields: [
        {
          key: 'imei',
          label: this.$t('qcdevice.deviceStatus.column.imei'),
        },
        {
          key: 'deviceType.deviceName',
          label: this.$t('qcdevice.deviceStatus.column.deviceType'),
        },
        {
          key: 'status',
          label: 'Status',
        },
      ],
      deviceFields: [
        {
          key: 'columnCheck',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'imei',
          label: this.$t('qcdevice.deviceStatus.column.imei'),
          sortable: false,
        },
        {
          key: 'deviceType.deviceName',
          label: this.$t('qcdevice.deviceStatus.column.deviceType'),
          sortable: false,
        },
      ],
      filterApi: {
        deviceTypes: null,
        status: null,
        orderBy: [JSON.stringify({ ibeacon_id: 'asc' })],
        devicetype: {
          devicetype: [],
        },
      },
      selected: {
        device: [],
      },
      selectedModel: {
        device: {},
      },
      allSelected: {
        device: {},
      },
      indeterminate: {
        device: true,
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      totalPages: 0,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'imei',
      sortDesc: false,
      isEdit: false,
      responseModal: {
        title: 'Registrasi Beacon Berhasil',
        ibeaconId: null,
        vehicleId: null,
        status: null,
      },
      set: {
        ibeaconId: '',
        companies: null,
      },
      form: {
        note: null
      },
      formOld: {
        ibeaconId: null,
      },
      show_model: null,
      show: [
        { key: 'ibeacon', label: 'Beacon' },
        { key: 'company_name', label: 'Company Name' },
        { key: 'domain_name', label: 'Domain Name' },
      ],
      isAddFavorit: false,
      addFavorit: null,
      showModal: false,
      titleModal: 'Registrasi Beacon',
      companies: {
        companies: [],
      },

      formStatus: 'create',
      status: '',
      listDeleted: [],
      filteredItems: [],
      vehicleTypes: [],
      isLoading: false,
      showDeviceType: false,
      vehicleYear: null,
      debounceTimer: null,
      accordionVisible: false,

      ibeaconList: [],
      isSubmitting: false,
      isDeleting: false,
      modalConfirm: false,

      deviceStatuses: [],
      deviceTypes: [],
      deviceList: [],
      selectedDevices: [],
      isTabDomain: true,
      statusLists: {
        200: 'Terkirim',
        unregistered: 'Tidak Terdaftar',
        failed: 'Gagal',
        loading: 'loading',
      },
      tabItemInput: {
        byImei: '',
      },
      disableSaveBtn: true,
    }
  },
  validations: {
    form: {
        companies: { required },
        deviceStatusId: { required },
        deviceType: { required },
    }
  },
  computed: {
    /**
     * Total no. of records
     */

    title() {
      return 'Create Status Dan Historical'
    },
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
    }),
    apiClient() {
      return {
        get: this.queries.get,
      }
    },
    queries() {
      return {
        get: async (param) => {
          let payload = {
            filters: `imei:eq:${param.q ?? ''}`,
          }
          if (param.companyName || param.deviceName) {
            payload = {
              filters: `companyName:like:${param.companyName ?? "''"};deviceName:like:${
                param.deviceName ?? ''
              }`,
              page: param.page ?? 1,
              size: param.size ?? 10,
            }
          }
          const response = await toolsAxios.get('/device', { params: payload })
          response.data.data?.forEach((val) => {
            val['can_delete'] = true
          })
          return response?.data
        },
      }
    },
  },
  async created() {
    this.$v.form.$touch()
    await this.getDeviceStatuses()
  },
  watch: {
    selectedDevices(newValue) {
        this.disableSaveBtn = !(newValue.length > 0)
    },
},
  
  methods: {
    async getDevices() {
      this.isLoading = true
      const params = {
        page: this.currentPage,
        size: this.perPage,
        q: this.filter,
      }

      if (this.sortBy == '') {
        this.sortBy = 'imei'
        this.sortDesc = true
      }

      let sortDirection = this.sortDesc ? 'desc' : 'asc'
      params.sorts = `${this.sortBy}:${sortDirection}`

      let filters = []

      if (this.form.companies) {
        filters.push('companyName:eq:' + this.form.companies.name)
      }

      if (this.form.deviceType) {
        filters.push('deviceName:eq:' + this.form.deviceType.name)
      }

      if (filters.length > 0) {
        params.filters = filters.join(';')
      }

      const res = await toolsAxios.get('/device', { params }).catch((error) => {
        this.handleError(error)
      })
      if (!res) return

      this.filteredItems = res.data.data
      this.deviceList = res.data.data
      this.totalRows = res.data.total_count
      this.totalPages = res.data.total_pages
      this.isLoading = false
    },

    async getDeviceStatuses() {
      const res = await smsAxios.get('/device-status')

      this.deviceStatuses = res.data.data
    },

    async getDeviceTypes() {
        const deviceTypes = await toolsAxios.get('/qcdevice/devicetypes')

        this.deviceTypes = deviceTypes.data.map((item) => {
            return {
                id: item.device_code,
                name: item.device_name
            }
        })
    },

    async onChangeCompany() {
        await this.getDevices()
    },

    async onChangeDevice() {
        await this.getDevices()
    },

    async handleSave() {
      this.disableSaveBtn = true
      const deviceStatusLogs = this.selectedDevices.map((device) => {
          return {
              imei: device.imei,
              note: this.form.note,
              device_status_id: this.form.deviceStatusId.device_status_id,
          }
      })

      const payload = {
          device_status_logs: deviceStatusLogs
      }

      await smsAxios
      .post('/device-status-log/bulk', payload)
      .then((responAxio) => {
        this.responModal(responAxio.data)
      })
      .catch((err) => {
        this.handleError(err)
      })

      this.disableSaveBtn = false
    },

    async getDataForMainTable(imeis) {
      const selectedDevices = imeis?.map(async (imei) => {
        try {
          this.isLoadingTable = true
          const response = await this.queries.get({ q: imei })
          let [data] = response.data.length > 0 ? response.data : []
          if (response.data.length === 0) {
            data = {};
            data['imei'] = imei;
            data['deviceType'] = {};
            data['deviceType']['deviceName'] = '-';
            data['status'] = this.statusLists.unregistered;
        } else {
            data['deviceType'] = data['deviceType'] || {};
            data['deviceType']['deviceName'] = data.deviceType?.deviceName || '-';
            data['status'] = '-';
        }
          if (!this.selectedDevices?.find((e) => e.imei === data.imei))
            this.selectedDevices?.push(data)
        } catch (error) {
          console.log(error)
        }
      })
      await Promise.all(selectedDevices)

      this.isLoadingTable = false
    },

    /**
     * Search the table data with search input
     */

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    async addDeviceStatusLog() {
      this.isTabDomain = true

      await this.getDeviceStatuses()
      await this.getDeviceTypes()
      
      this.$bvModal.show('modal-create')
    },
    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value
    },
    nextSetup(item) {
      localStorage.setItem('device', JSON.stringify(item))
      this.$router.push({
        name: 'Setting Device',
      })
    },
    toggleAll(checked, param) {
      if (checked) {
        this.$set(this.allSelected.device, this.currentPage, true);
        for (let i = 0; i < this.deviceList.length; i++) {
          if (!this.selectedModel[param][this.deviceList[i].imei]) {
            this.selected[param].push(this.deviceList[i]);
          }
          this.$set(this.selectedModel[param], this.deviceList[i].imei, true);
        }
      } else {
        for (let i = 0; i < this.deviceList.length; i++) {
          if (this.selectedModel[param][this.deviceList[i].imei]) {
            this.$set(this.selectedModel[param], this.deviceList[i].imei, false);

            var selectedIdx = this.selected[param].findIndex((item) => {
              return item.imei === this.deviceList[i].imei;
            });

            if (selectedIdx !== -1) {
              this.selected[param].splice(selectedIdx, 1);
            }
          }
        }
        this.$set(this.allSelected.device, this.currentPage, false);
      }
    },
    checkTable(event, data, param) {
      if (event) {
        this.selected[param].push(data.item)
      } else {
        var selectedIdx = this.selected[param].findIndex((item) => {
          return item.imei === data.item.imei
        })

        if (selectedIdx !== -1) {
          this.selected[param].splice(selectedIdx, 1)
        }
      }
    },

    async setTo() {
      this.$bvModal.show('device-setup')
    },

    selectDevices() {
        this.$bvModal.hide('modal-create')

        this.selectedDevices = this.selected.device
        this.isLoadingTable = false

        if (this.isTabDomain) return

        const imeis = [
        ...new Set(
          this.tabItemInput?.byImei
            .split(',')
            .map((item) => item.trim())
            .filter((item) => item !== '')
        ),
      ]

        if (this.selectedDevices?.length > 0)
        this.selectedDevices = this.selectedDevices.filter((item) => imeis.includes(item.imei))

      this.getDataForMainTable(imeis)
    },
    beforeEdit(item) {
      this.showDeviceType = false
      this.isEdit = true
      this.formStatus = 'update'
      this.$bvModal.show('modal-create')
      this.form = {
        ibeaconId: item.ibeacon_id,
      }
      this.formOld = {
        ibeaconId: item.ibeacon_id,
      }
    },

    clearDelete() {
      this.allSelected.device = {}
      this.selectedModel.device = {}
      this.selected.device = []
    },
    resetModal() {
      this.formStatus = 'create'
      this.accordionVisible = false
    },
    resetData() {
        this.selectedDevices = []
        this.form = {
            note: null,
            deviceStatusId: null,
        }      
    },
    responModal() {
      this.resetData()
      this.$toast.success(`Device Status Log Berhasil dibuat `)
      this.$root.$emit('bv::toggle::collapse', 'accordion-3')
      setTimeout(() => {
        if (!this.accordionVisible) {
          this.$root.$emit('bv::toggle::collapse', 'accordion-3')
        }
      }, 500)

      this.responseModal.status = 'Register Success'
    },

    async prosesSubmit() {
      let input = {
        ibeacon_id: this.form.ibeaconId,
      }

      toolsAxios
        .post('/ibeacon', input)
        .then((responAxio) => {
          this.responModal(responAxio.data)
        })
        .catch((err) => {
          this.handleError(err)
        })
    },

    handleError(error) {
      if (error.response) {
        const errorStatus = error.response.status
        const errorData = error.response.data

        if (errorData.errors) {
          Object.values(errorData.errors).forEach((value) => {
            this.$toast.error(value)
          })
          return
        }

        if (errorStatus === 400 && errorData.details) {
          errorData.details.forEach((element) => {
            this.$toast.error(`${errorData.error}: ${element.field} ${element.message}`)
          })
        } else if (errorStatus === 409 && errorData.details) {
          errorData.details.forEach((element) => {
            if (
              element.message == 'ibeacon already exists' ||
              element.message == 'ibeacon already exist'
            ) {
              this.$toast.error('Beacon already exist')
            }
          })
        } else if (errorStatus === 401) {
          this.$toast.error(errorData.error)
          localStorage.removeItem('token')
          localStorage.removeItem('tokenAccess')
          this.$router.push({ name: 'Login' })
        } else if (errorStatus === 403) {
          this.$toast.error(errorData.error)
        } else {
          this.$toast.error(errorData.error)
        }
      } else if (error.request) {
        this.$toast.error(error.response.statusText)
      } else {
        this.$toast.error(error.message)
      }
    },

    handleSubmit() {
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal-create')
        this.resetModal()
      })
    },
    changeStatus(status) {
      this.status = status
      if (this.selected.ibeacon.length > 0) {
        this.showModal = true
      } else {
        this.$toast.error(`Minimal memilih satu atau lebih dari data di bawah.`)
      }
    },
    customLabel(item) {
      return `${item.name} (${item.domainName})`
    },
    customLabelDevice(item) {
      if (item.deviceName) return `${item.deviceName}`
    },
    showDeviceTypes() {
      this.showDeviceType = true
      const interval = setInterval(() => {
        this.$refs.deviceTypeRef.isOpen = true
        if (this.$refs.deviceTypeRef) clearInterval(interval)
      }, 100)
    },
    changePage(newPage) {
      this.currentPage = newPage
      this.getDevices()
    },
    resetFilter(e) {
      this.currentPage = 1
      this.perPage = e
      this.getDevices()
    },
    searchData: debounce(function () {
      this.getDevices()
    }, 600),

    allowAlphanumeric(event) {
      const key = event.key
      const allowedKeys = [
        'Backspace',
        'Delete',
        'Tab',
        'Enter',
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp',
        'ArrowDown',
      ]

      // Regular expression for alphanumeric characters
      const isAlphanumeric = /^[a-zA-Z0-9]$/

      if (!isAlphanumeric.test(key) && !allowedKeys.includes(key)) {
        event.preventDefault()
      }
    },

    sortingChanged(ctx) {
      if (ctx.sortBy == '') {
        return
      }

      this.sortDesc = ctx.sortDesc
      this.sortBy = ctx.sortBy

      this.getDevices()
    },

    async deleteDeviceStatusLog(ibeacon) {
      try {
        const res = await toolsAxios.delete(`/ibeacon/${ibeacon}`)
        return res
      } catch (error) {
        this.handleError(error)
      }
    },
    getSelectedDeviceStatusLogs() {
      return this.selected.ibeacon.map((item) => item.ibeacon_id)
    },
    confirmDelete() {
      this.modalConfirm = true
    },
    async toDelete() {
      this.isDeleting = true
      const ibeacons = this.getSelectedDeviceStatusLogs()

      let promises = []
      for (const element of ibeacons) {
        const res = await this.deleteDeviceStatusLog(element)
        if (!res) continue
        promises.push()
      }

      Promise.all(promises).then(() => {
        this.$toast.success(`Data berhasil dihapus`)
      })

      await this.getDeviceList()
      this.clearDelete()

      this.isDeleting = false
    },
  },
}
</script>
<style>
.formulate-input ul.formulate-input-errors {
  font-style: normal;
  font-size: 80%;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" />
    <p class="mb-4">Input status data dan historical dari device</p>
    <div class="clearfix mc-btn-group__list">
      <div class="float-end">
        <b-button
          @click="$router.push({ name: 'Device Status Log' })"
          variant="outline-primary"
          menu-class="dropdown-menu-end"
          class="ms-3"
        >
          <i class="bx bx-arrow-back"></i> {{ $t('global.back') }}
        </b-button>
      </div>
    </div>

    <div
      class="row mb-3"
      v-if="this.getAccessFunc('addNewBeacon') || hasAccessAll('ibeacon:read')"
    >
      <div class="col-md-6"></div>

      <div class="col-md-6 d-flex justify-content-end gap-2">
        <div
          class="mc-table-filter"
          v-if="hasAccessAll(['ibeacon:create'])"
        >
            <b-button variant="primary" :disabled="disableSaveBtn || !form.deviceStatusId" type="button" @click="handleSave()">
            <i class="bx bxs-save"></i> {{ this.$t('global.save') }}
            </b-button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="clearfix col-2 mb-4">
                <label class="required">{{ $t('qcdevice.deviceStatus.selectStatus') }}</label>
                <multiselect
                    v-model="form.deviceStatusId"
                    :options="deviceStatuses"
                    placeholder="Pilih Status"
                    label="status"
                    :class="{
                    'is-invalid': $v.form.deviceStatusId.$error,
                    }"
                />
                <div v-if="$v.form.deviceStatusId.$error" class="invalid-feedback mt-0">
                  <span v-if="!$v.form.deviceStatusId.required">
                    Status Wajib Terisi
                  </span>
                </div>
            </div>

            <div class="d-flex align-items-center justify-content-between h-100">
                <div>
                    <span class="required">Daftar Device</span>
                </div>
                <div class="float-end">
                    <div class="mc-table-filter"
                        v-if="hasAccessAll(['ibeacon:create'])"
                        >
                        <a class="popup-form btn btn-primary" href="javascript: void(0);" @click="addDeviceStatusLog">
                            <i class="bx bx-plus"></i> {{ $t('global.addField') }}
                        </a>
                    </div>
                </div>
            </div>

            <div class="table-responsive my-3 border border-1">
              <b-table
                class="datatables"
                :items="selectedDevices"
                :fields="selectedDevicesFields"
                show-empty
                :empty-text="$t('global.emptyTable')"
                :empty-filtered-text="$t('global.emptyFilteredTable')"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                :busy="isLoading"
                @hidden="resetModal"
                @sort-changed="sortingChanged"
                no-local-sorting
              >
                <template #head(edit)>
                  <div class="table-header" @click.stop>
                    {{ $t('domain.table.edit') }}
                  </div>
                </template>

                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>

                <template #cell(edit)="data">
                  <span
                    id="tool-edit"
                    class="icon-fill_edit"
                    v-if="hasAccessAll('ibeacon:update')"
                    v-b-tooltip.hover.top
                    title="Edit DeviceStatusLog"
                    @click="beforeEdit(data.item)"
                  ></span>
                </template>

                <template #cell(status)="data">
                    {{ data.item.status == 0 ? '-' : data.item.status }}
                </template>
              </b-table>
            </div>

            <template>
                <b-form-group label="Note" label-for="note" class="mb-3">
                    <b-form-textarea
                    v-model="form.note"
                    id="note"
                    placeholder="Masukkan catatan"
                    rows="6"
                    :disabled="isLoading"
                    />
                </b-form-group>
            </template>

          </div>
        </div>
      </div>
    </div>

    <b-modal
      class="mc-modal"
      id="modal-create"
      title="Pilih Device"
      size="xl"
      centered
      scrollable
      @hidden="resetModal"
    >
        <div class="card mc-card mc-card-front">
            <div class="card-body">
                <b-tabs content-class="text-muted">
                    <b-tab class="p-3 border-0" active @click="() => (isTabDomain = true)">
                        <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                            <i class="fas fa-home"></i>
                        </span>
                        <span class="d-none d-sm-inline-block">Filter by Domain</span>
                        </template>
                        <b-row class="align-items-center">
                            <b-col md="6">
                            <label>Domain</label>
                            <multiselect
                                v-model="form.companies"
                                :options="companies.companies"
                                placeholder="Pilih Company"
                                :custom-label="customLabel"
                                :class="{
                                'is-invalid': $v.form.companies.$error,
                                }"
                                @input="onChangeCompany"
                            ></multiselect>
                            </b-col>
                            <b-col md="6">
                            <label>Tipe Perangkat</label>
                            <multiselect
                                v-model="form.deviceType"
                                :options="deviceTypes"
                                placeholder="Pilih Device"
                                label="name"
                                :class="{
                                'is-invalid': $v.form.deviceType.$error,
                                }"
                                @input="onChangeDevice"
                            />
                            </b-col>
                        </b-row>
                        <div class="table-responsive my-3 border border-1">
                            <b-table
                                class="datatables"
                                :items="deviceList"
                                :fields="deviceFields"
                                show-empty
                                :empty-text="$t('global.emptyTable')"
                                :empty-filtered-text="$t('global.emptyFilteredTable')"
                                :per-page="perPage"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :filter="filter"
                                :filter-included-fields="filterOn"
                                @filtered="onFiltered"
                                :busy="isLoading"
                                @hidden="resetModal"
                                @sort-changed="sortingChanged"
                                no-local-sorting
                            >
                                <template #head(columnCheck)>
                                <div class="form-check" @click.stop>
                                    <b-form-checkbox
                                    @change="toggleAll($event, 'device')"
                                    v-model="allSelected.device[currentPage]"
                                    :indeterminate="indeterminate.device"
                                    :value="true"
                                    :unchecked-value="false"
                                    ></b-form-checkbox>
                                </div>
                                </template>

                                <template #cell(columnCheck)="data">
                                <div class="form-check">
                                    <b-form-checkbox
                                    @change="checkTable($event, data, 'device')"
                                    v-model="selectedModel.device[data.item.imei]"
                                    :value="true"
                                    :unchecked-value="false"
                                    ></b-form-checkbox>
                                </div>
                                </template>
                            </b-table>
                        </div>
                        <div class="row mt-10">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                <label class="d-inline-flex align-items-center">
                                    <span>Menampilkan</span>
                                    <span>
                                    <b-form-select
                                        class="form-select form-select-sm"
                                        v-model="perPage"
                                        size="sm"
                                        :options="pageOptions"
                                        @change="resetFilter"
                                    />
                                    </span>
                                    <span>entri.&nbsp;&nbsp;</span>
                                    <span
                                    >Menampilkan&nbsp;
                                    <strong>
                                        {{ filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0 }}
                                    </strong>
                                    &nbsp;sampai&nbsp;
                                    <strong>
                                        {{
                                        currentPage != totalPages
                                            ? currentPage * perPage
                                            : (currentPage - 1) * perPage + filteredItems.length
                                        }}
                                    </strong>
                                    &nbsp;dari&nbsp;
                                    <strong>{{ totalRows }}</strong>
                                    &nbsp;entri.
                                    </span>
                                </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                <ul class="pagination pagination-rounded mb-0">
                                    <!-- pagination -->
                                    <b-pagination
                                    v-model="currentPage"
                                    :total-rows="totalRows"
                                    :per-page="perPage"
                                    @change="changePage"
                                    ></b-pagination>
                                </ul>
                                </div>
                            </div>
                            </div>
                    </b-tab>
                    <b-tab title="Input IMEI" @click="() => (isTabDomain = false)">
                        <div class="mc-report__filter-wrapper">
                        <b-row class="py-2 mb-2">
                            <b-form-group>
                            <b-form-textarea
                                v-model="tabItemInput.byImei"
                                placeholder="Ketik IMEI"
                                rows="15"
                                class="mt-2"
                            ></b-form-textarea>
                            </b-form-group>
                            <div class="d-flex justify-content-start gap-2">
                            <i class="icon-outline_info float-end pt-2"></i>
                            <h6 class="pt-2 text-muted">
                                Gunakan separator koma (,) untuk input IMEI lebih dari 1
                            </h6>
                            </div>
                        </b-row>
                        </div>
                    </b-tab>
                </b-tabs>
            </div>
        </div>

        <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col sm="12" md="8" class="mc-modal__filter-footer-fav"> </b-col>
          <b-col sm="12" md="4" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" @click="cancel" class="me-3"> Batal </b-button>
            <b-button type="submit" :disabled="isLoading" variant="primary" @click="selectDevices">
              Simpan
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <confirmation v-if="modalConfirm" :modal.sync="modalConfirm" @confirmed="toDelete" />
  </Layout>
</template>
